"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSbarState = void 0;
exports.defaultSbarState = {
    textbox: '',
    namePlaceholder: 'eg. Wan Chai',
    nameFilter: 'Filter',
    nameSave: 'Save',
};
